module.exports = __webpack_public_path__ + "img/piute.8942f89b.png";